<template>
  <el-card class="stat-card" :style="cssVars">
    <div slot="header" class="clearfix">
      <span>{{ title }}</span>
      <el-button
        @click="$emit('refresh')"
        style="float: right; padding: 3px 0; color: white"
        type="text"
      >
        <i class="fa fa-refresh"></i>
      </el-button>
    </div>
    <div class="stat-card__accomplished-progress">
      <span class="bold f-2">{{ stat.total }}</span>
      <span>張訂單</span>
      <el-progress :percentage="getTotal(stat)" :color="color"></el-progress>
    </div>
    <div class="stat-card__accomplished-detail">
      <el-row>
        <el-col :span="12">{{ stat.waitForDriver }} 張待載客</el-col>
        <el-col v-if="stat.loadFactor" :span="12">
          {{ stat.loadFactor }} 張已載客
        </el-col>
        <el-col :span="12">{{ stat.waitForSubmit }} 張找司機</el-col>
      </el-row>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'StatCard.vue',
  props: {
    title: String,
    stat: {
      type: Object,
      default() {
        return {}
      },
    },
    color: {
      type: String,
      default() {
        return '#18A55D'
      },
    },
  },
  methods: {
    getTotal(stat) {
      if (this.title === '今日載客狀況') {
        if (stat.total === 0) return 0
        console.log((stat.loadFactor / stat.total) * 100)
        return Math.ceil((stat.loadFactor / stat.total) * 100)
      } else {
        if (stat.total === 0) return 0
        return Math.ceil((stat.waitForDriver / stat.total) * 100)
      }
    },
  },
  computed: {
    cssVars() {
      return {
        '--card-header-color': this.color,
      }
    },
  },
}
</script>

<style scoped>
.stat-card {
  border-radius: 5px;
}

.stat-card >>> .el-card__header {
  padding: 7px 12px;
  color: white;
  background: var(--card-header-color);
}

.stat-card .stat-card__accomplished-progress {
  margin-bottom: 10px;
}

.stat-card .stat-card__accomplished-detail {
}

.stat-card >>> .el-input.el-input--suffix {
  min-width: 70px;
}

.bold {
  font-weight: bold;
}

.f-2 {
  font-size: 2.2em;
}
</style>



// WEBPACK FOOTER //
// src/pages/longTermCare/StatCard.vue